import { Component, OnInit } from '@angular/core';
import {  ListTableComponent  } from '@ppl/ui';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { Router } from '@angular/router';
import { ClaimsService } from '../../../services/claims.service';
import { SectionsService } from '../../../services/sections.service';
import { AllowListAuthStore } from '../../../shared/authorization/allow-list-auth.store';
import { SharedDataService } from '../../../shared/services/shared-data-service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'ppl-case-manager-list',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './case-manager-list.component.html',
  styleUrl: './case-manager-list.component.css',
})
export class CaseManagerListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_CASE_MANAGER_DATA;
  pageId: string = PAGE_CONSTANTS.CASE_MANAGER_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  isReadOnly = false;
  programName!: string;
  lazyLoad = true;

  constructor(
    private router: Router,
    private sectionService: SectionsService,
    private sharedDataService: SharedDataService,
    private claimsService: ClaimsService,
    private userService: UserService,
    private allowListStore: AllowListAuthStore
  ) {}

  ngOnInit() {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }

  rowClicked(rowDetail: any) {
    this.userService.setLeadEntry('caseManager');
    this.sectionService.setFlow('caseManager');
    this.userService.setSelectedId(rowDetail.caseManagerId);
    this.claimsService.setFormData('case_manager', rowDetail);
    this.router.navigate(['/home/caseManagerDetails']);
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }
}
